export const formatReviewSubject = (review) => {
    if (!review?.reviewFor) return '—';
    const subject = review.reviewFor;
    if (review.reviewForModel === 'NonMember') {
        return `${subject.name || '—'} · ${subject.webID || ''}`.trim();
    }
    const lastOld = subject.oldNames?.length ? subject.oldNames[subject.oldNames.length - 1] : null;
    const name = lastOld ? `${lastOld}(${subject.godName || ''})` : (subject.godName || '');
    return `${subject.godID || ''} - ${name} - ${subject.webID || ''}`.trim() || subject._id;
};

export const formatReviewer = (review) => {
    if (review?.reviewByDisplayName) return review.reviewByDisplayName;
    const c = review?.reviewBy;
    if (!c || typeof c === 'string') return c || '—';
    return c.displayName || c.username || c.useremail || '—';
};

export const godMemberStatusIcon = (status) => {
    switch (status) {
        case 'active':
            return '✅';
        case 'hold':
            return '⏸️';
        case 'stop':
            return '🛑';
        case 'expiring':
            return '‼️';
        case 'expired':
        case 'cancelled':
            return '❌';
        case 'changedName':
            return '🔁';
        default:
            return '—';
    }
};

export const memberStatusIcon = (review) => {
    if (review.reviewForModel !== 'godMember') return '—';
    return godMemberStatusIcon(review.reviewFor?.status);
};

/** Normalized view counts; falls back to legacy views/likes fields when present. */
export const getViewObject = (review) => {
    if (review?.viewObject) {
        return {
            slgWebView: review.viewObject.slgWebView ?? 0,
            reviewWebView: review.viewObject.reviewWebView ?? 0,
            otherView: review.viewObject.otherView ?? 0,
        };
    }
    return {
        slgWebView: review?.views ?? 0,
        reviewWebView: 0,
        otherView: review?.likes ?? 0,
    };
};

export const formatViewObjectCompact = (review) => {
    const v = getViewObject(review);
    const total = v.slgWebView + v.reviewWebView + v.otherView;
    return `${v.slgWebView}/${v.reviewWebView}/${v.otherView}/${total}`;
};
